import React, { useState } from "react";
import Sidebar, { SidebarProvider } from "../../components/navigation/Sidebar";
import { Globe, Image, Download, History, TrendingUp } from "lucide-react";

export default function PinterestCSVGenerator() {
  const [selectedSite, setSelectedSite] = useState("");
  const [selectedAccount, setSelectedAccount] = useState("");
  const [selectedPins, setSelectedPins] = useState([]);

  return (
    <SidebarProvider>
      <div className="min-h-screen bg-[#f7f9fc]">
        <Sidebar />

        <main className="main-content p-8">
          {/* Page Header */}
          <div className="mb-6">
            <h1 className="text-2xl font-bold text-gray-900">
              Pinterest CSV Generator
            </h1>
            <p className="text-sm text-gray-500">
              Select articles and export Pinterest-ready CSV files
            </p>
          </div>

          {/* Main Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            
            {/* LEFT COLUMN */}
            <div className="lg:col-span-2 space-y-6">
              
              {/* Website Selector */}
              <div className="bg-white rounded-xl border shadow-sm p-5">
                <div className="flex items-center gap-2 mb-4">
                  <Globe className="w-5 h-5 text-blue-600" />
                  <h2 className="font-semibold text-gray-800">
                    Select Website
                  </h2>
                </div>

                <select
                  value={selectedSite}
                  onChange={(e) => setSelectedSite(e?.target?.value)}
                  className="w-full rounded-lg border px-4 py-2 text-sm focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Choose a WordPress website…</option>
                  <option value="site1">Prestige Recipes</option>
                  <option value="site2">Cozy Family Recipes</option>
                </select>
              </div>

              {/* Articles List / Empty State */}
              <div className="bg-white rounded-xl border shadow-sm p-10 flex flex-col items-center justify-center text-center">
                <Image className="w-10 h-10 text-gray-300 mb-3" />
                <p className="font-medium text-gray-700">
                  No Website Selected
                </p>
                <p className="text-sm text-gray-500">
                  Select a WordPress website to load articles
                </p>
              </div>
            </div>

            {/* RIGHT SIDEBAR */}
            <div className="space-y-6">
              
              {/* Pinterest Account */}
              <div className="bg-white rounded-xl border shadow-sm p-5">
                <div className="flex items-center gap-2 mb-4">
                  <TrendingUp className="w-5 h-5 text-red-500" />
                  <h2 className="font-semibold text-gray-800">
                    Pin Preview & Export
                  </h2>
                </div>

                <label className="block text-sm font-medium text-gray-600 mb-1">
                  Pinterest Account
                </label>
                <select
                  value={selectedAccount}
                  onChange={(e) => setSelectedAccount(e?.target?.value)}
                  className="w-full rounded-lg border px-4 py-2 text-sm focus:ring-2 focus:ring-red-400"
                >
                  <option value="">Choose account…</option>
                  <option value="acc1">Dana Recipes</option>
                </select>
              </div>

              {/* Selected Pins */}
              <div className="bg-white rounded-xl border shadow-sm p-6 text-center">
                <p className="text-sm font-medium text-gray-700 mb-1">
                  Selected Pins
                </p>
                <p className="text-xs text-gray-500 mb-4">
                  {selectedPins?.length} pins selected
                </p>

                <div className="flex flex-col items-center text-gray-400">
                  <Image className="w-8 h-8 mb-2" />
                  <p className="text-sm">No Pins Selected</p>
                  <p className="text-xs">
                    Select articles from the left
                  </p>
                </div>
              </div>

              {/* Export Options */}
              <div className="bg-white rounded-xl border shadow-sm p-5 space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-600 mb-1">
                    Export name (optional)
                  </label>
                  <input
                    type="text"
                    placeholder="Auto-generated filename"
                    className="w-full rounded-lg border px-4 py-2 text-sm"
                  />
                </div>

                <label className="flex items-center gap-2 text-sm text-gray-600">
                  <input type="checkbox" className="rounded" />
                  Export without article links
                </label>

                <button
                  disabled
                  className="w-full mt-3 flex items-center justify-center gap-2 rounded-lg bg-gray-200 text-gray-500 py-2 text-sm font-medium cursor-not-allowed"
                >
                  <Download className="w-4 h-4" />
                  Generate & Download CSV
                </button>

                <button className="w-full flex items-center justify-center gap-2 rounded-lg border py-2 text-sm text-gray-700 hover:bg-gray-50">
                  <History className="w-4 h-4" />
                  View Export History
                </button>
              </div>
            </div>
          </div>
        </main>
      </div>
    </SidebarProvider>
  );
}